module.exports = __webpack_public_path__ + "static/media/earth-cropped.f177c075.webp";